
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healthcare",
      function () {
        return require("private-next-pages/healthcare/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healthcare"])
      });
    }
  